module.exports = __webpack_public_path__ + "img/videogame_asset.b8663183.svg";